import { isApp } from '@/assets/ts/checkApp'

function hideLayoutsInApp() {
	const $hideElements = document.querySelectorAll<HTMLElement>(
		['.bs-header', '.mobile-nav', '.bs-footer'].join(),
	)

	Array.from($hideElements).forEach(v => {
		v.style.display = 'none'
	})
}

function transAnchorToSelfRedirect() {
	Array.from(
		document.querySelectorAll<HTMLAnchorElement>('a[target="_blank"]'),
	).forEach(v => {
		v.target = '_self'
	})
}

export default function hybridPage() {
	if (isApp) {
		if (document.readyState !== 'complete') {
			document.addEventListener('DOMContentLoaded', transAnchorToSelfRedirect)
		} else {
			hideLayoutsInApp()
			transAnchorToSelfRedirect()
		}
	}
}
